import { Suspense, useEffect } from 'react';
import { AuthProvider } from '@/providers';
import { Snackbar, ErrorBoundary, AppLogo } from '@/components';
import { TooltipProvider, TOOLTIP_DELAY_MS } from '@/components/ui/Tooltip';
import { OverlayManager } from '@/features/OverlayManager';
import { AlertNotifications } from '@/features/AlertNotifications';
import { useNavigationHistory, useWebSocketConnection } from '@/hooks';
import { useRegisterGlobalNavigate } from '@/hooks/useRegisterGlobalNavigate';
import Router from './Router';

function WebSocketManager() {
    useWebSocketConnection();
    return null;
}

function App() {
    useRegisterGlobalNavigate();
    useNavigationHistory();

    useEffect(() => {
        const loader = document.getElementById('app-loader');
        if (loader) {
            loader.classList.add('fade-out');
            setTimeout(() => loader.remove(), 300);
        }
    }, []);

    return (
        <Suspense fallback={<AppLogo />}>
            <TooltipProvider delayDuration={TOOLTIP_DELAY_MS}>
                <AuthProvider>
                    <ErrorBoundary fallback={null}>
                        <WebSocketManager />
                    </ErrorBoundary>
                    <Router />
                    <Snackbar />
                    <AlertNotifications />
                    <OverlayManager />
                </AuthProvider>
            </TooltipProvider>
        </Suspense>
    );
}

export default App;
